import { useMemo } from 'react'
import ms from 'ms'
import moment from 'moment'
import _ from 'lodash'
import * as blueprint from '@adc/blueprint'
import { OnlineAuctionSegmentBid } from '@adc/sdk/types'
import useCountdown from '../../../../hooks/useCountdown'

export const useCounterOfferCountdown = (
  counterOffer: OnlineAuctionSegmentBid
) => {
  if (!counterOffer) return -1
  const currentServerTime = blueprint.bidding.hooks.useMomentCurrentTime()

  const endTime = useMemo(() => {
    const expirationDate = _.get(counterOffer?.terms, 'expiration_date')
    if (!moment(expirationDate).isValid()) return currentServerTime
    return moment(expirationDate)
  }, [counterOffer, currentServerTime])

  // @ts-ignore needs types
  const { secondsRemaining } = useCountdown({
    // @ts-ignore
    currentServerTime,
    endTime,
    updateInterval: ms('500ms'),
  })

  return secondsRemaining
}
